import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { TEACHER_ROLES } from '../../../user/constants/teacher-roles.constants';

@Pipe({
  name: 'formatTeacherGroups',
  standalone: false,
})
export class FormatTeacherGroupsPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value?: string[]): string {
    if (Array.isArray(value) && value.find((group) => group === TEACHER_ROLES.manager)) {
      return this.translocoService.translate('pap/portfolio/manager');
    }

    return this.translocoService.translate('pap/portfolio/teacher');
  }
}
